import React, { Component } from 'react';
import Tasks from './Tasks.js';
import MapComponent from './Map.js';
import Header from './Header.js';
import './Home.css';

class Home extends Component {
  render() {
    return (
      <div className="home">
        <Header />
        <div className="home--map">
          <MapComponent zoomLevel={1}/>
        </div>
        <div className="home--projects">
          <Tasks />
        </div>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/Home.js